import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StatsBar } from '../components/StatsBar';
import { UseCases } from '../components/UseCases';
import { PainPoints } from '../components/PainPoints';
import { PacksSection } from '../components/PacksSection';
import { MidCTA } from '../components/MidCTA';
import { BonusSection } from '../components/BonusSection';
import { Testimonials } from '../components/Testimonials';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-neutral-950 text-neutral-300 font-inter selection:bg-brand-500/30" data-id="element-168">
      <main data-id="element-169">
        <HeroSection data-id="element-170" />
        <StatsBar data-id="element-171" />
        <UseCases data-id="element-172" />
        <PainPoints data-id="element-173" />
        <PacksSection data-id="element-174" />
        <MidCTA data-id="element-175" />
        <BonusSection data-id="element-176" />
        <Testimonials data-id="element-177" />
        <PricingSection data-id="element-178" />
        <FinalCTA data-id="element-179" />
      </main>
      <footer className="py-8 text-center text-neutral-600 text-sm bg-neutral-950 border-t border-neutral-900" data-id="element-180">
        <p data-id="element-181">
          © {new Date().getFullYear()} Prompt Wear. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}